import React from "react";
import { createRoot } from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import store, { persistor } from "./store";
import "./index.css";
import { IntlProvider } from "react-intl";
import enMessages from "./locales/en.json";
import frMessages from "./locales/fr.json";
// Create a wrapper component to connect to Redux and provide Intl context
function IntlAppWrapper() {
  const languageFromRedux = useSelector((state) => state.language?.locale);
  const language = languageFromRedux || localStorage.getItem("lang") || "fr";

  const messages = {
    en: enMessages,
    fr: frMessages,
  };

  return (
    <IntlProvider
      locale={language}
      messages={messages[language]}
      defaultLocale="fr"
    >
      <App />
    </IntlProvider>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);

// Conditional StrictMode - only in production
const AppWithConditionalStrictMode = () => {
  const AppContent = (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <IntlAppWrapper />
      </PersistGate>
    </Provider>
  );

  // Only use StrictMode in production
  if (process.env.NODE_ENV === "production") {
    return <React.StrictMode>{AppContent}</React.StrictMode>;
  }

  return AppContent;
};

root.render(<AppWithConditionalStrictMode />);
